import React, { useMemo } from 'react';
import { Button, Table } from 'antd';
import { useAuth } from '../../../contexts/userContext/userContext';
import useTranslation from '../../../hooks/translation/useTranslation';
import ridePromotionsTableColumns from './ridePromotionsTableColumns';
import { deleteRidePromotionService } from '../../../../services/admin/ridePromotionServices';

function RidePromotionsTable({ data, refetchData }) {
  const { trans } = useTranslation();
  const { ticketBookingOptions: { stations } } = useAuth();

  const stationsMap = useMemo(() => {
    const map = new Map();
    stations?.forEach((station) => {
      map.set(station.value, station.label_ka);
    });
    return map;
  }, [stations]);

  const handleDelete = async (id) => {
    await deleteRidePromotionService(id);
    refetchData();
  };

  return (
    <Table
      dataSource={data?.map((station) => ({
        ...station,
        start_station: stationsMap?.get(station?.start_station_code),
        end_station: stationsMap?.get(station?.end_station_code),
        delete: (
          <Button
            type="danger"
            onClick={() => handleDelete(station.id)}
          >
            {trans('delete')}
          </Button>
        ),
      }))}
      columns={ridePromotionsTableColumns.map(
        (col) => ({
          ...col,
          title: trans(col.title),
        }),
      )}
    />
  );
}

export default RidePromotionsTable;
